import { Model } from "pinia-orm";
import Question from "./Question";

export default class Category extends Model {
  static name = "Category";
  static entity = "categories";

  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      createdAt: this.attr(null),
      updatedAt: this.attr(null),
      order: this.attr(null),
      value: this.boolean(false),
      indeterminate: this.boolean(false),
      name: this.string(),
      questions: this.hasMany(Question, "categoryUuid"),
      categoryUuid: this.attr(null),
      questionnaireUuid: this.attr(null),
    };
  }
}
